import React from "react";
import "../../../css/Transparencia/presupuesto-participativo.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilePdf,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";

const PresupuestoParticipativo = () => (
    <div className="ppart-full-bg">
        <div className="ppart-container">
            <h1 className="ppart-title">
                <FontAwesomeIcon icon={faInfoCircle} className="ppart-icon-title" />
                Presupuesto Participativo
            </h1>
            <p className="ppart-desc">
                <strong>La Secretaría de Desarrollo Humano y Gobierno</strong>, en
                cumplimiento de la Ordenanza 69/2020, presenta el{" "}
                <strong>Presupuesto Participativo</strong>.
            </p>
            <div className="ppart-block">
                <p>
                    El Poder Ejecutivo Municipal determina, anualmente, el monto afectado
                    al Presupuesto Participativo.
                </p>
                <p>
                    <span className="ppart-highlight">
                        La cuantía queda determinada por:{" "}
                        <b>
                            10% de lo destinado a Obras Públicas en el presupuesto ejecutado
                            del año anterior como mínimo.
                        </b>
                    </span>
                </p>
            </div>
            <div className="ppart-links">
                <div className="ppart-link-block">
                    <FontAwesomeIcon icon={faFilePdf} className="ppart-link-icon" />
                    <span>
                        Más información:&nbsp;
                        <a
                            href="https://ciudaddeoliva.gob.ar/wp-content/uploads/2022/03/Ord-69-2020.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="ppart-link"
                        >
                            Ver PDF
                        </a>
                    </span>
                </div>
            </div>
        </div>
    </div>
);

export default PresupuestoParticipativo;
